import type { SaveEvent } from 'containers/LeaveDialogue/LeaveDialog';
import FileSaver from 'file-saver';
import type { IpfCertificateFormFields } from '../../CertificateRequestForm';
import type { IpfCertificateCommandFactory } from '../IpfCertificateModel';

type GenerateNimpeeCertificateCommand = {
  values: IpfCertificateFormFields;
  transitionUrl?: SaveEvent;
};

export const generateNimpeeCertificate: IpfCertificateCommandFactory<
  GenerateNimpeeCertificateCommand
> = (cmdContext) => async (command) => {
  const response = await cmdContext.queryClient.fetchQuery(
    cmdContext.api.query({
      method: 'POST',
      url: '/os/generate-nimpee-cert',
      data: command.values,
    }),
  );
  const csr = await response.blob();
  const blob = new Blob([csr], { type: 'application/octet-stream' });
  FileSaver.saveAs(blob, 'nimpee.csr');

  if (command.transitionUrl) {
    cmdContext.navigate(command.transitionUrl);
  }
};
